export const paymentRoute = {
  PAYMENT_LIST: '/payment/list',
  PAYMENT_DETAIL: '/payment/detail/:recordId',
};
